// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'element-ui/lib/theme-chalk/index.css';
import 'vue-easytable/libs/themes-base/index.css'

import Vue from 'vue'
import 'babel-polyfill'
import App from './App'
import store from './vuex/store'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import {VTable,VPagination} from 'vue-easytable'

Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$http = axios

const loginCacheName = process.env.NODE_ENV !== 'development' ? `isLogin${(process.env.VERSION)}` : 'isLogin'

Vue.mixin({
  data() {
    return {
      loginCacheName
    }
  }
})

router.beforeEach((to, from, next) => {
  // debugger;
  if(to.path === '/login')  {  
    next()  
  }  // 如果即将进入登录路由，则直接放行

  else {     //进入的不是登录路由
  
    if(to.meta.requireAuth &&  !sessionStorage.getItem(loginCacheName) ) {
      next({ path: '/login' })      
      sessionStorage.setItem(loginCacheName , 'loging');
    } 

    //下一跳路由需要登录验证，并且还未登录，则路由定向到  登录路由

    else { 
      next()
    }
  }  //如果不需要登录验证，或者已经登录成功，则直接放行      

})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  // watch:{
  //   "$route" : 'checkLogin'
  // },
  // created() {
  //   this.checkLogin();
  // },
  // methods:{
  //   checkLogin(){
  //
  //     //检查是否存在session
  //     // if(!this.getCookie('session')){
  //     //   this.$router.push('/login');
  //     // }
  //     // else{
  //     //   this.$router.push('/home');
  //     // }
  //   }
  // }
})


// WEBPACK FOOTER //
// ./src/main.js